import { Form } from "react-router-dom";
import { useNavigate, useNavigation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { codeActions,  usersActions, testStrategyActions } from "../store/user";
import { useSelector } from "react-redux";
import SuccessModal from "./SuccessModal";
import ErrorModal from "./ErrorModal";
import { useState, useEffect } from "react";
import "./Question.css";
// import img1 from "./images/1.png";
// import img2 from "./images/p3.png";
// import img3 from "./images/Screenshot 2024-12-06 at 7.25.52 PM.png";
// import img4 from "./images/p4.png";


export default function Question() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDisabled, setIsDisabled] = useState(false)
  const [remainingTime, setRemainingTime] = useState(0);

  const {loading: loadingTest} = useSelector(state => state.myUser.testStrategyState)

  useEffect(() => {
    // Check localStorage for saved timer state
    const savedTime = localStorage.getItem("remainingTime");
    const savedTimestamp = localStorage.getItem("timestamp");

    if (savedTime && savedTimestamp) {
        const elapsedTime = Math.floor((new Date().getTime() - parseInt(savedTimestamp, 10)) / 1000);
        const updatedTime = parseInt(savedTime, 10) - elapsedTime;

        if (updatedTime > 0) {
            setIsDisabled(true);
            setRemainingTime(updatedTime);

            // Restart countdown
            const interval = setInterval(() => {
                setRemainingTime((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setIsDisabled(false);
                        localStorage.removeItem("remainingTime");
                        localStorage.removeItem("timestamp");
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        } else {
            localStorage.removeItem("remainingTime");
            localStorage.removeItem("timestamp");
        }
    }
}, []);


  function handleStartegyClick(){
    const countDownTime = 1 * 60 // 1 mins in secs
    dispatch(testStrategyActions(new Date().toISOString()));
    setIsDisabled(true);
    setRemainingTime(countDownTime);

    // Save timer state to localStorage
    localStorage.setItem("remainingTime", countDownTime);
    localStorage.setItem("timestamp", new Date().getTime());

    const interval = setInterval(() => {
      setRemainingTime((prev) => {
        if(prev<=1)
        {
          clearInterval(interval);
          setIsDisabled(false);
          localStorage.removeItem("remainingTime");
          localStorage.removeItem("timestamp");
          return 0;
        }

        return prev = prev-1;
      });
    }, 1000);  
  }

  function handleRedirectA(){
    window.open("https://my.newtonschool.co/course/1niq52e5bdrg/assignment/srwoj8amr2h5")
  }

  function handleRedirectB(){
    window.open("https://my.newtonschool.co/course/gm1m4c1m6nzi/assignment/fvhutwtat5zg")
  }

  function handleRedirectC(){
    window.open("https://my.newtonschool.co/course/th8ejn5lw5xt/assignment/c74pn3i1iphd")
  }

  // const navigation = useNavigation();
  // const onSubmitting = navigation.state === "submitting";
  

  const testStrategyState = useSelector((state) => state.myUser.testStrategyState);
  const { loading, error, errorMsg, successMsg, status } = testStrategyState;

  // function handleSubmit(e) {
  //   e.preventDefault();
  //   const formData = new FormData(e.target);
  //   const inputData = Object.fromEntries(formData);

  //   // Dispatch action to run code against test cases
  //   dispatch(codeActions(inputData));
  // }

  function handleCloseSuccessModal() {
    dispatch(usersActions.testStrategy({ type: "TEST_STRATEGY_RESET" }));
    navigate("../");
  }

  function handleCloseErrorModal() {
    dispatch(usersActions.testStrategy({ type: "TEST_STRATEGY_RESET" }));
    navigate("../question")
  }

  function handleCancel() {
    navigate("../");
  }

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};


if(loadingTest){
  return <p className="loading">Fetching Your code from Newton Playground....</p>;
}
  

  return (
    <div className="questionArea">
      <h1>Newton Premier League</h1>
     <hr></hr>
     {/* <div className="game-theory-section">

  <h2></h2>
  <img src={img1}/>

  <h2>Applications</h2>
  <ol>
    <li>
      <strong>Economic Competition</strong>
      <p>Two companies can choose to advertise or not:</p>
      <ul>
        <li>
          If both cooperate (don’t advertise): Each saves money (3 points each).
        </li>
        <li>
          If one advertises while the other doesn’t: The advertiser gains the market (5 points), while the other loses customers (0 points).
        </li>
        <li>
          If both advertise: Costs increase, and neither gets a significant advantage (1 point each).
        </li>
      </ul>
      <p>
        <strong>Implication:</strong> Companies are tempted to advertise (defect), but this mutual defection 
        leads to wasteful spending. Cooperation (not advertising) would benefit both.
      </p>
    </li>
    <img src={img2}/>

    <li>
      <strong>Environmental Agreements</strong>
      <p>Two countries decide whether to reduce emissions (cooperate) or continue polluting (defect):</p>
      <ul>
        <li>
          If both cooperate (reduce emissions): Both benefit from a healthier environment (3 points each).
        </li>
        <li>
          If one defects (pollutes) while the other cooperates: The defector gains economic growth (5 points), while the cooperator bears the cost (0 points).
        </li>
        <li>
          If both defect: Both suffer environmental degradation and minimal economic benefit (1 point each).
        </li>
      </ul>
      <p>
        <strong>Implication:</strong> Countries are tempted to defect for short-term gains, but cooperation 
        leads to a better outcome for all.
      </p>
    </li>
    <img src={img3}/>
    <li>
      <strong>Team Projects</strong>
      <p>Two teammates decide whether to put effort (cooperate) or slack off (defect):</p>
      <ul>
        <li>
          If both cooperate: They complete the project successfully (3 points each).
        </li>
        <li>
          If one defects: The defector benefits without working (5 points), while the cooperator does all the work (0 points).
        </li>
        <li>If both defect: The project fails (1 point each).</li>
      </ul>
      <p>
        <strong>Implication:</strong> Trust and accountability are crucial to ensure mutual cooperation.
      </p>
    </li>
    <img src={img4}/>
  </ol>
</div>     */}
      <SuccessModal
        openModal={successMsg}
        message={successMsg}
        handleCloseModal={handleCloseSuccessModal}
      />
      <ErrorModal
        openModal={error && status !== 422}
        message={errorMsg}
        handleCloseModal={handleCloseErrorModal}
        block={true}
      />
      {/* <Form method="POST" onSubmit={handleSubmit}>
        {error && status === 422 && (
          <ul>
            {errorMsg.map((e) => (
              <li key={e.msg}>{e.msg}</li>
            ))}
          </ul>
        )}
        <label htmlFor="python">Python Code</label>
        <textarea name="py" id="python" required placeholder="def make_move(moves):"/>
        <div className="buttonContainer">
          <button
            type="button"
            onClick={handleCancel}
            disabled={onSubmitting}
            className="cancelButton"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={onSubmitting}
            className="submitButton"
          >
            Upload
          </button>
          
        </div>
      </Form> */}
      {/* <div className="buttonContainer">
          <button onClick={handleStartegyClick} disabled={isDisabled} className="testButton">{isDisabled ? `Disabled for ${formatTime(remainingTime)}` : "Test Your Strategy"}</button>
          <button
            type="button"
            onClick={handleCancel}
            className="cancelButton"
          >
            Cancel
          </button>
          <button onClick={handleRedirect}>Question Link</button>
        </div> */}
      <div className="buttonContainer">
      <div className="questionLink">
        <button style={{width:"100px"}}
        onClick={handleRedirectA} 
        className="bottomButtons questionLinkButton "
      >
        <strong>Question Link Batch A</strong>
      </button>
      <button style={{width:"100px"}}
        onClick={handleRedirectB} 
        className="bottomButtons questionLinkButton "
      >
        <strong>Question Link Batch B</strong>
      </button>
      <button style={{width:"100px"}}
        onClick={handleRedirectC} 
        className="bottomButtons questionLinkButton "
      >
        <strong>Question Link Batch C</strong>
      </button>
      </div>
            <div className="bottomButtons">
              <p>Disabled until leaderboard is generated.....</p>
              {/* <button
                onClick={handleStartegyClick}
                disabled={isDisabled}
                className="testButton"
              >
                {isDisabled ? `Disabled for ${formatTime(remainingTime)}` : "Test Your Strategy"}
              </button> */}
              <button
                className="testButton"
                disabled={true}
              >
                {"Testing Disabled"}
              </button>
              <button
                type="button"
                onClick={handleCancel}
                className="cancelButton"
              >
                Leaderboard
              </button>
            </div>
        </div>
    </div>
  );
}
